import React, { ReactNode } from "react";
import clsx from "clsx";

import {
  EVariantExamsHistory,
  getVariantsClassNames
} from "components/VetExams/ExamHistoryItem/helper";

import useStyles from "./styles";

interface IProps {
  date: string;
  variant?: EVariantExamsHistory;
  facilityName: string;
  sideInfoButton: ReactNode;
  extraInfo: string;
}

const EntryHeaderInfo = (props: IProps) => {
  const { date, facilityName = "", variant, sideInfoButton, extraInfo } = props;
  const classes = useStyles();
  const { detailsClassName } = getVariantsClassNames(variant);

  return (
    <div className={clsx(classes.headerEntryInfo, detailsClassName)}>
      <div className={classes.row}>
        <span className={clsx(classes.date, detailsClassName)}>{date}</span>
        <span className={clsx(classes.extraInfo, detailsClassName)}>
          {extraInfo}
        </span>
      </div>
      <div className={classes.row}>
        <span className={clsx(classes.facilityName, detailsClassName)}>
          {facilityName}
        </span>
        {sideInfoButton}
      </div>
    </div>
  );
};

export default EntryHeaderInfo;
